import { Dropdown, Icon } from "semantic-ui-react";

import { useProfile } from "../../../../authentication/state/profile";
import DropdownMenu from "../../../../ui/components/DropdownMenu/DropdownMenu";
import DropdownMenuItems from "../../../../ui/components/DropdownMenu/DropdownMenuItems";
import themeColors from "../../../../ui/constants/themeColors";
import { useWhatsNewUnseen } from "../../../../whatsNew/state/whatsNewSeen";

import useSecondaryMenuOptions from "../hooks/useSecondaryMenuOptions";

export default function SecondaryMenu({ organization }) {
	const profile = useProfile();
	const whatsNewUnseen = useWhatsNewUnseen();

	const options = useSecondaryMenuOptions({ organization });

	return (
		<DropdownMenu
			icon={
				<div style={{ position: "relative" }}>
					<Icon fitted name="bars" style={{ width: 20 }} />

					{whatsNewUnseen && (
						<div
							style={{
								backgroundColor: themeColors.BLUE,
								width: 10,
								height: 10,
								borderRadius: "50%",
								position: "absolute",
								top: 0,
								right: -1,
								border: "2px solid var(--color-bg-nav)",
							}}
						/>
					)}
				</div>
			}
		>
			{() => (
				<>
					<Dropdown.Header>{profile?.email}</Dropdown.Header>

					<Dropdown.Divider style={{ margin: "10px 0" }} />

					<DropdownMenuItems options={options} />
				</>
			)}
		</DropdownMenu>
	);
}
